import React, { useEffect, useRef } from 'react'
import ReCaptcha, { type ReCAPTCHAProps } from 'react-google-recaptcha'
import styled from 'styled-components'

import { QA } from '@hozana/tests/constants'

export type TCaptchaProps = Omit<ReCAPTCHAProps, 'sitekey'> & {
  value?: string
  scale?: number
  lang?: string
}

export const Wrapper = styled.div<Pick<TCaptchaProps, 'scale'>>`
  overflow: hidden;

  iframe {
    transform-origin: 0 0;
    transform: scale(${(props) => props.scale || 1});
  }
`

export const Captcha: TFCC<TCaptchaProps> = ({ value, scale, lang = 'fr', ...otherProps }) => {
  const domElement = useRef(null)

  useEffect(() => {
    if (!value && domElement) {
      domElement.current.reset()
    }
  }, [value])

  return (
    <Wrapper scale={scale}>
      <ReCaptcha
        data-testid={QA.CONTACT_PAGE.CAPTCHA}
        ref={domElement}
        hl={lang}
        size="normal"
        sitekey={CONF_KEYS.RECAPTCHA_API_KEY}
        {...otherProps}
      />
    </Wrapper>
  )
}
